import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios'
import store from './store'
import PageLoader from './components/Common/PageLoader'
import VueElementLoading from "vue-element-loading";
import ServerError from './components/Common/500'
Vue.component("VueElementLoading", VueElementLoading);
import { VueEditor } from "vue2-editor";
Vue.component('VueEditor', VueEditor)
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
Vue.component(VueCropper);
import CryptoJS from 'crypto-js';
Vue.use(CryptoJS)
import OtpInput from "@bachdgvn/vue-otp-input";
Vue.component("v-otp-input", OtpInput);
Vue.component('PageLoader', PageLoader)
Vue.component('ServerError', ServerError)
Vue.config.productionTip = false

window.axios = require('axios')

axios.defaults.baseURL = 'https://pmr-api.forest.kerala.gov.in'
Vue.prototype.baseURL = "https://pmr-api.forest.kerala.gov.in"
Vue.prototype.mediaURL = "https://pmr-api.forest.kerala.gov.in/file/get?key="
Vue.prototype.mediaURLnew = "https://pmr-api.forest.kerala.gov.in/wp?key="

// axios.defaults.baseURL ='http://localhost:4003'
// Vue.prototype.baseURL = 'http://localhost:4003'
// Vue.prototype.mediaURL = 'http://localhost:4003/file/get?key='
// Vue.prototype.mediaURLnew = 'http://localhost:4003/wp?key='

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
